export default __webpack_public_path__ + "static/media/trace.e0c7f411.svg";